module.exports = __webpack_public_path__ + "assets/images/17a09f942b52e7721ea5060620e1cf74.png";